/**
 * 返回值Date，均为Date类型，非moment类型
 */

import moment from 'moment';
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

function Calendar() {
  // do nothing
}

/**
 * 校验是否为日期
 * @param {Any} date 校验内容
 * @returns Boolean
 */
Calendar.isDate = function (date) {
  // moment校验日期格式更广泛
  return !isNaN(+moment(date));
};

/**
 * 根据指定格式，格式化日期，无效日期返回指定内容，无指定值时返回 '-'
 * @param {Date|Any} date
 * @param {String} format
 * @param {Any} format
 * @returns
 */
Calendar.format = function (date, format, defValue) {
  if (isNaN(+moment(date))) return defValue === undefined ? '-' : defValue;
  return moment(date).format(format || dateTimeFormat);
};

/**
 * 根据指定格式，格式化时间戳，无效日期返回指定内容，无指定值时返回 '-'
 * @param {Date|Any} date
 * @param {String} format
 * @param {Any} format
 * @returns
 */
Calendar.formatFromCusType = function (date, cusFormat, format, defValue) {
  if (isNaN(+moment(date, cusFormat))) return defValue === undefined ? '-' : defValue;
  return moment(date, cusFormat).format(format || dateTimeFormat);
};

// 日期转换格式

export function date2(val) {
  return moment(val).format('MM-DD');
}

export function date3(val) {
  return moment(val).format('YYYY.MM.DD');
}

/**
 * 获取当前时间
 */
Calendar.now = function () {
  return new Date();
};

/**
 * 获取日期开始00:00:00
 * @param {Date} date
 * @returns
 */
Calendar.startDate = function (date) {
  if (Calendar.isDate(date)) return moment(date).startOf('day').toDate();
  return moment().startOf('day').toDate();
};

/**
 * 获取日期结束23:59:59
 * @returns
 */
Calendar.endDate = function (date) {
  if (Calendar.isDate(date)) return moment(date).endOf('day').toDate();
  return moment().endOf('day').toDate();
};

/**
 * 获取月的第一天
 * @param {Date} date
 * @returns
 */
Calendar.startOfMonth = function (date) {
  if (Calendar.isDate(date)) return moment(date).startOf('month').toDate();
  return moment().startOf('month').toDate();
};

/**
 * 获取月的最后一天
 * @param {Date} date
 * @returns
 */
Calendar.endOfMonth = function (date) {
  if (Calendar.isDate(date)) return moment(date).endOf('month').toDate();
  return moment().endOf('month').toDate();
};

/**
 * 获取当前月的最后一天
 * @returns
 */
Calendar.endOfCurrentMonth = function () {
  return moment().endOf('month').toDate();
};

/**
 * 返回日期的星期x
 * @param {Date} date
 */
Calendar.toWeek = function (date) {
  if (Calendar.isDate(date)) {
    return `星期${'日一二三四五六'.charAt(moment(date).toDate().getDay())}`;
  }
  return '';
};

/**
 * 获得日期n天后的日期，n为负数时则为n天前的日期
 * @param {Date} date
 * @param {Number} n
 */
Calendar.obtainDate = function (date, n = 0) {
  var newDate = {};
  if (Calendar.isDate(date)) {
    n = Number(n) || 0;
    date = moment(date).toDate();

    newDate.y = date.getFullYear();
    newDate.m = date.getMonth();
    newDate.d = date.getDate() + n;
    return new Date(newDate.y, newDate.m, newDate.d);
  } else {
    return new Date();
  }
};

/**
 * 获取日期的时间戳
 * @param {Date} date
 * @returns Number
 */
Calendar.timstamp = function (date) {
  if (Calendar.isDate(date)) return +moment(date);
  return +moment();
};

/**
 * 转换时间  返回举例 =>2022年第1季度
 * @param {Date} date
 * @returns Number
 */
Calendar.changeToQuarter = function (date) {
  if (date && Calendar.isDate(date))
    return moment(date).year() + '年第' + moment(date).quarter() + '季度';
  return '';
};
export default Calendar;



// WEBPACK FOOTER //
// ./src/utils/calendar.js